<app-header></app-header>
<div id="auth" class="container-fluid">
  <div id="box_auth">
    <form action="" method="post">
      <div class="title_auth margin-0">{{ 'ForgetPassword' | translate}}</div>
<!--      <div class="excerpt_auth">{{ 'ForgetPasswordDescription2' | translate}}</div>-->
      <div class="box_auth_row">
        <input type="mobile" id="mobile" name="mobile" placeholder="{{ 'MobileNumberOrEmailAddress' | translate}}" [(ngModel)]="user.mobile" (keyup.enter)="loginUser()">
      </div><!-- .login_row -->
      <div class="box_auth_row">
        <div class="pull-left">
          <button class="forget_pass" type="button" #test (click)="loginUser()" [ngClass]="{'increase_width': pomodoroRepository.ltrDirection}">
            {{ 'ForgetPassword' | translate}}
            <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="registerSpinner"></mat-spinner>
          </button>
        </div>
        <div class="auth_links">
          <div>
            <a [routerLink]="['/login']">{{ 'ReturnLogin' | translate}}</a>
          </div>
        </div>
        <div class="clearfix"></div>
      </div><!-- .login_row -->
    </form>
  </div><!-- .box_auth -->
</div><!-- #auth -->
<!--<button (click)="testRenderer()">Test</button>-->
<app-footer></app-footer>
